import { ThunkAction, ThunkDispatch } from "redux-thunk";
import Prefix from 'src/helpers/ApiPrefix';
import AXIOS from 'src/helpers/Axios';
import Headers from 'src/helpers/Headers';
import { emailLogAction } from "src/reducers/emailLogReducer";
import {  emailLogActionTypes } from "src/types/actionTypes";
import { EmailLog } from "src/types/emailLogTypes";
import { ErrorAction, SuccessAction } from "src/types/responseTypes";


export const EmailLogFailure = (message: string): ErrorAction => {
    return {
        type: emailLogActionTypes.EMAIL_LOG_REQUEST,
        payload: { message: message }
    }
}
export const EmailLogSuccess = (payload: any): SuccessAction<any> => {
    return {
        type: emailLogActionTypes.FETCH_EMAIL_LOG_SUCCESS,
        payload: payload,
    }
}

export const EmailLogsRequest = (filter: any, pageNo: number, limit: number):
    ThunkAction<Promise<void>, {}, {}, emailLogAction> => {
    return (dispatch: ThunkDispatch<{}, {}, emailLogAction>) => {
       dispatch({ type:emailLogActionTypes.EMAIL_LOG_REQUEST,payload: { loading:true,data:[]} });
        return AXIOS.post(`${Prefix.api}/admin/email/logs`, { filter,  pageNo, limit } , { headers: Headers() }).then(res => {
            if (res) {
                const { data } = res;
                const invoices: EmailLog = data.result
                dispatch(EmailLogSuccess(invoices))
            }
        }).catch((e) => {
            if (e.response) {
                dispatch(EmailLogFailure(e.response.data.message));
            }
            else {
                dispatch(EmailLogFailure(e.message));
            }
        })
    }
}











